export enum AccountTypes {
	CARRIER = "carrier",
	RECEIVER = "receiver",
	ADMIN = "admin",
}
